// extracted by mini-css-extract-plugin
module.exports = {"card":"Meme_card__1KUyB","container":"Meme_container__Y3eDr","name":"Meme_name__1xXzA","caption":"Meme_caption__1CUxO"};